import { CLEAR_MODAL, OPEN_MODAL } from './types'
import { ADD_FRIEND_SUCCESS, REMOVE_FRIEND_SUCCESS, WINK_SUCCESS, CHAT_SUCCESS } from '../userProfile/types'
import { DELETE_IMAGE_SUCCESS, FETCH_MY_PROFILE_SUCCESS } from '../myProfile/types'
import * as MODAL from 'components/Modal/modalTypes'

const handleMessages = ({ payload = {}, error = {} }) => {
  let errorMessage = error?.globalErrors?.[0]?.message || error?.details?.[0]?.message
  if (errorMessage) {
    return { error: errorMessage }
  }

  if (payload.messages?.length) {
    const success = payload.data?.success || payload.data === null
    return { [success ? 'success' : 'error']: payload.messages[0] }
  }
}

const modals = (state = [], { type, modalId, data, payload, error }) => {
  const message = handleMessages({ payload, error })

  if (message) {
    return [{ modalId: MODAL.PROFILE_UPDATE_MODAL, data: message }, ...state]
  }

  switch (type) {
    case CLEAR_MODAL:
      return state.filter(e => e.modalId !== modalId)

    case OPEN_MODAL:
      return [{ modalId, data }, ...state]

    case ADD_FRIEND_SUCCESS:
    case REMOVE_FRIEND_SUCCESS:
      return [{ modalId: MODAL.FRIEND_MODAL, data: payload.ServiceOperationResult }, ...state]

    case WINK_SUCCESS:
      return [{ modalId: MODAL.WINK_MODAL, data: payload.ServiceOperationResult }, ...state]

    case CHAT_SUCCESS:
      return payload.success || payload.url ? state : [{ modalId: MODAL.MESSAGE_MODAL, data: payload }, ...state]

    case DELETE_IMAGE_SUCCESS:
      return [{ modalId: MODAL.MESSAGE_MODAL, data: { text: payload.ServiceOperationResult.messageText } }, ...state]

    case FETCH_MY_PROFILE_SUCCESS:
      return /nophoto/.test(payload.media[0].uri) ? state.filter(m => m.modalId != MODAL.GALLERY_MODAL) : state

    default:
      return state
  }
}

export default modals
